// extracted by mini-css-extract-plugin
export default {"container":"_4W2WIdQE4sQ0ALAiVYqfQc","heading":"_7Jc9TQ3f8WBVEEhdjpMpqU"};